import "./style/w3";
import "./style/w3-theme-blue";
import "./style";
import "./style/fontello/css/myfont";
import "./style/fontello/css/animation";
import App from "./components/app";

export default App;
